
import clsx from 'clsx'

/**
 * Loading Spinner Component
 * Displays a customizable loading spinner
 */
function LoadingSpinner({ 
  size = 'md', 
  color = 'primary',
  className = '',
  text = '',
  overlay = false 
}) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  }

  const colorClasses = {
    primary: 'border-[var(--x3-border)] border-t-primary-600',
    secondary: 'border-[var(--x3-border)] border-t-[var(--x3-text-muted)]',
    white: 'border-white/30 border-t-white',
    success: 'border-[var(--x3-border)] border-t-success-600',
    warning: 'border-[var(--x3-border)] border-t-warning-600',
    error: 'border-[var(--x3-border)] border-t-error-600'
  }

  const spinnerClasses = clsx(
    'animate-spin rounded-full border-2',
    sizeClasses[size],
    colorClasses[color],
    className
  )

  const content = (
    <div
      className={clsx(
        'flex flex-col items-center justify-center',
        text && 'space-y-2'
      )}
      role="status"
      aria-label={text || 'Loading'}
    >
      <div className={spinnerClasses} aria-hidden="true" />
      {text && (
        <p className="text-sm text-[var(--x3-text-muted)]">
          {text}
        </p>
      )}
    </div>
  )

  if (overlay) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="rounded-md border border-[var(--x3-border)] bg-[var(--x3-surface)] p-6 shadow-lg">
          {content}
        </div>
      </div>
    )
  }

  return content
}

export default LoadingSpinner
